<div
    class="flex flex-col justify-center items-center gap-6 min-w-full h-screen font-brandon container"
>
    <img src="images/Logo_Zehentmoar_RGB.svg" alt="" srcset="" class="h-24" />
    <div
        class="flex flex-col items-center gap-8 space-y-4 md:space-y-6 p-6 sm:p-8"
    >
        <h1
            class="font-bold text-red text-xl md:text-2xl text-center leading-tight tracking-tight"
        >
            {{ "notFound.siteNotFound" | translate }}
        </h1>
        <a
            data-umami-event="not-found-button-click"
            [href]="languageService.getLanguageCode + '/start'"
        >
            <app-button>
                {{ "notFound.toHome" | translate }}
            </app-button>
        </a>
    </div>
</div>
